import React from 'react'
import ProductsHero from '../components/products/ProductsHero'
import BestSellingProducts from '../components/home/BestSellingProducts'
import SEO from '../components/seo/SEO'

export default function Products() {
  return (
    <>
      <SEO
        title="Products | Custom Logo Mats Johannesburg – Premium SA Entrance Mats"
        description="Browse our full range of custom logo mats in Johannesburg. Super Deco, Novamat, Marshall Scribe, Jet Print, Coir, Berber Point, PVC Coil, and Rubber Fingertip mats. ZAR pricing, 2–3 day delivery."
        keywords="custom logo mat products South Africa, Super Deco mat Johannesburg, Novamat South Africa, Marshall Scribe mat SA, Berber Point logo mat, PVC coil mat Gauteng, branded entrance mats SA, ZAR logo mats"
        url="https://www.logobrandeddoormats.co.za/products"
        image="https://www.logobrandeddoormats.co.za/images/sectionimages/products hero.png"
      />
      <ProductsHero />
      <BestSellingProducts />
    </>
  )
}
